import React, { Component, PropTypes } from 'react';

class DummyLink extends Component {

  static propTypes = {
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    FRN_rawResponses: PropTypes.array
  }

  render() {
    const { href, text, FRN_rawResponses = [] } = this.props;

    return (
      <a className="frankly-core-DummyLink" href={href}>{text + ' ' + JSON.stringify(FRN_rawResponses).substring(0, 10)}</a>
    );
  }
}

export default DummyLink;



// WEBPACK FOOTER //
// ./app/components/core/DummyLink.js